export default __webpack_public_path__ + "static/media/UpperGI_set_up_Male_.38c653b5.png";